export default function DSA_Tutorial() {
  return <div>DSA_Tutorial Component</div>;
}
